<template>
  <div class="container">
  <div class="quyu">
    <div class="home-banner">
        <img class="banner-bg" src="@/assets/电信.png" alt="">
        <div class="textBox typeArea">
        <p class="centerBanner animated zoomIn">电信服务商客户满意度管理</p>
        </div>
    </div>
    <div class="project">
      <div class="proj-box">
        <div class="proj-cont">
          <div style="padding-bottom: 45px;"></div>
          <div class="common-title">
            场景说明 
          </div>
          <div class="proj-text">
            <p>       电信服务行业的竞争势态已从扩展新增客户转为对存量客户的争夺，因而客户满意度成为主要的业绩指标。如何通过大数据把握客户满意度，正日益成为刚性需求。</p>
          </div>
          <div style="padding-bottom: 55px;"></div>
        </div>
      </div>
      <div class="proj-box" style="background:#F3F4F7">
        <div class="proj-cont">
          <div style="padding-bottom: 80px;"></div>
          <div class="common-title">
            业务需求点 
          </div>
          <div style="padding-bottom: 80px;"></div>
          <div class="proj-t">
            <div class="proj-sanjiao">
              <img src="@/assets/sanjiao.png" alt="">
            </div>
            <div class="proj-text" style="font-size: 14px;">
              对现有数据和业务进行梳理，提出解决方案并进行基于实际数据的产品测试
            </div>
          </div>
          <div style="padding-bottom: 50px;"></div>
        </div>
      </div>
    </div>
    <div class="proj-box">
      <div class="proj-cont">
        <div style="padding-bottom: 60px;"></div>
        <div class="common-title">
          解决方案 
        </div>
        <div class="proj-text" >
          <p style="text-indent: 0;">使用部盾的DSS和报告生成系统，进行如下工作：</p>
          <p style="">客户的负面反应行为与视频质量的关联关系需要单独建模，以区别因质量原因和非质量原因触发的抱怨，因此需要对抱怨原因进行质量溯源</p>
          <p style="">对于视频传输质量，建立基于丢包率、时延等物理指标的综合质量评分和分指标刻画体系，包括历史、现状和未来预测</p>
          <p style="">对于服务质量，建立基于响应时间、处理时间和服务态度等指标的综合质量评分和分指标画像体系，包括历史、现状和未来预测</p>
          <p style="">建立相应的报告和看板系统，做为抓手</p>
        </div>
        <div style="clear: both;"></div>
      </div>
    </div>
    <div class="proj-box">
      <div class="proj-cont">
        <div style="padding-bottom: 40px;"></div>
        <div class="proj-fangan">
          <img src="@/assets/组4-1.png" style="width: 1200px;height;588px;" alt="">
        </div>
        <div style="padding-bottom: 40px;"></div>
      </div>
    </div>
  </div>  
</div>
</template>

<script>
export default {
  name: "dianxin",
  data() {
    return {
    };
  },
  methods: {
      
  },
  mounted() {

  },
}
</script>

<style scoped>
   
</style>